import { CorporateCrest } from './Crest';
import { CREST_MOTTO } from '../data/content';

export const Footer = () => (
  <footer className="bg-[#0F0506] text-[#B99C8B]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-4">
          <CorporateCrest className="w-10 h-12" />
          <div>
            <p className="font-serif font-semibold text-xl text-[#F2E5CF] tracking-wide">THE LEÓN FOUNDATION</p>
            <p className="font-mono text-[10px] tracking-[0.3em] text-gold mt-1">{CREST_MOTTO}</p>
          </div>
        </div>
        <p className="mt-6 text-sm text-[#94756A] leading-relaxed max-w-sm">
          A private research institution seated at St. Bellmore. In perpetuity.
        </p>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#94756A] mb-5">Programmes</p>
        <ul className="space-y-3 text-sm">
          <li><a href="#pillars" className="hover:text-gold transition-colors" data-testid="footer-link-legal">Legal & Sovereign Counsel</a></li>
          <li><a href="#pillars" className="hover:text-gold transition-colors" data-testid="footer-link-medical">The Longevity Programme</a></li>
          <li><a href="#pillars" className="hover:text-gold transition-colors" data-testid="footer-link-science">Resonance & Matter</a></li>
        </ul>
      </div>
      <div className="md:col-span-4">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#94756A] mb-5">Correspondence</p>
        <p className="text-sm leading-relaxed text-[#94756A]">
          The León Foundation<br />
          One Bellmore Bluff, St. Bellmore<br />
          enquiries@leonfoundation.org
        </p>
      </div>
    </div>
    <div className="border-t border-[#47201F]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-[10px] tracking-[0.22em] uppercase text-[#94756A]">
        <span>© MDCCCXLII–MMXXVI The León Foundation</span>
        <span>All rights reserved, in perpetuity</span>
      </div>
    </div>
  </footer>
);
